var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDoItLater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 66,
    height: 57,
    viewBox: "0 0 66 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dettp29osa",
    d: "M0 0L66 0 66 57 0 57z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-771 -304) translate(362 168) translate(376 115) translate(33 21)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "h981y08m7b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dettp29osa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#777D87",
    d: "M55.844 22.001c-.754-.76-1.769-1.185-2.864-1.195l-25.302.002c1.524-1.336 4.24-3.757 5.545-5.62.99-1.41 1.124-3.383.344-5.024-.517-1.086-1.503-1.846-2.707-2.086-1.253-.25-2.569.11-3.521.961-2.211 1.978-4.827 3.383-7.356 4.742-3.012 1.618-5.858 3.147-8.106 5.563-1.484 1.47-1.96 1.467-2.746 1.465H9v1.378h.125c1.152.006 1.972-.118 3.746-1.877l.02-.02c2.092-2.255 4.842-3.732 7.754-5.296 2.601-1.398 5.29-2.843 7.625-4.93.627-.561 1.493-.798 2.316-.634.768.153 1.396.635 1.723 1.322.573 1.203.483 2.636-.227 3.65-1.299 1.85-4.215 4.402-5.616 5.628l-.085.074c-.378.331-.507.848-.328 1.317.177.465.616.766 1.117.766l25.804-.002c.717.007 1.385.285 1.88.784.493.498.762 1.164.755 1.874-.006.718-.288 1.392-.794 1.897-.504.504-1.174.78-1.89.771H32.653v1.38h9.442v2.662c0 .822-.522 2.1-1.218 2.662h-8.224v1.379h7.752v2.662c0 1.205-1.197 2.662-2.683 2.662h-6.758v1.379h6.062v2.662c0 1.206-1.197 2.662-2.683 2.662H17.447c-1.687 0-3.224-.93-4.711-1.829-1.295-.783-2.518-1.523-3.736-1.523v1.38c.828 0 1.889.641 3.012 1.32C13.586 47.922 15.37 49 17.447 49h16.895c2.331 0 4.074-2.134 4.074-4.041v-2.727c1.974-.369 3.379-2.264 3.379-3.976V35.25c1.052-.879 1.69-2.532 1.69-3.697V28.89h9.472c1.074 0 2.083-.418 2.845-1.18.762-.761 1.188-1.775 1.198-2.855.01-1.08-.4-2.093-1.156-2.855",
    mask: "url(#h981y08m7b)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoItLater);
export default __webpack_public_path__ + "static/media/icon-do-it-later.d497ea07078073f0ea1ec7a91c9fa741.svg";
export { ForwardRef as ReactComponent };